import { ChangeDetectionStrategy, Component, DestroyRef, computed, inject } from '@angular/core'
import { takeUntilDestroyed } from '@angular/core/rxjs-interop'
import { Event, Router, Scroll } from '@angular/router'
import { AppSignals } from '@appShared/services'

@Component({
    selector: 'app-site-footer',
    templateUrl: './site-footer.component.html',
    styleUrls: ['./site-footer.component.less'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true
})

export class SiteFooterComponent {
   private _appSignals = inject(AppSignals)
   currentYear = (new Date()).getFullYear()
   hideFooter: boolean
   // Deployed build version from the /config call — reflects the live slot during a canary.
   readonly clientVersion = computed(() => this._appSignals.siteConfig()?.version)

   constructor(
      router: Router,
      destroyRef: DestroyRef
   ) {

      router.events
         .pipe(takeUntilDestroyed(destroyRef))
         .subscribe((event: Event) => {
            if (event instanceof Scroll) {
               const url = event?.routerEvent?.url
               this.hideFooter = url.includes('registration-landing')
            }
         })
   }
}
